import { render, staticRenderFns } from "./OCRComp.vue?vue&type=template&id=0dbc1a86&scoped=true"
import script from "./OCRComp.vue?vue&type=script&lang=js"
export * from "./OCRComp.vue?vue&type=script&lang=js"
import style0 from "./OCRComp.vue?vue&type=style&index=0&id=0dbc1a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbc1a86",
  null
  
)

export default component.exports